export class MEState {
	public modalData: { [key: string]: any } = {};
}
